import React from 'react';

type ApplicantFooterProps = {
  showPrevNext: boolean;
  isFirst: boolean;
  isLast: boolean;
  onPrev: () => void;
  onNext: () => void;
  onSubmit: () => void;
  submitButtonRef?: React.Ref<HTMLButtonElement>;
};

const ApplicantFooter = ({
  showPrevNext,
  isFirst,
  isLast,
  onPrev,
  onNext,
  onSubmit,
  submitButtonRef,
}: ApplicantFooterProps) => {
  return (
    <footer className="footer-custom" data-testid="applicant-footer">
      <div className="container">
        <div className="vr-footer">
          <p className="vr-footer__support" data-testid="applicant-footer-support">
            Need help completing your application? Docuverus can be reached by phone at{' '}
            <strong className="vr-footer__emphasis">856.886.8843</strong> or by email at{' '}
            <strong className="vr-footer__emphasis">support@docuverus.com</strong>
          </p>
          <div className="vr-footer__actions">
            {showPrevNext && (
              <>
                <button
                  disabled={isFirst}
                  type="button"
                  className="modal-blue-btn vr-footer__button"
                  onClick={onPrev}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-arrow-left-circle"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"
                    />
                  </svg>
                  <span className="vr-footer__label">Previous</span>
                </button>
                <button
                  disabled={isLast}
                  type="button"
                  className="modal-blue-btn vr-footer__button"
                  onClick={onNext}
                >
                  <span className="vr-footer__label">Next</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-arrow-right-circle"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1 8a7 7 0 1 0 14 0A7 8 0 0 1 0 8a8 8 0 0 1 16 0M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z"
                    />
                  </svg>
                </button>
              </>
            )}
            <button
              disabled={!isLast}
              type="button"
              ref={submitButtonRef}
              className="modal-blue-btn vr-footer__button vr-footer__submit"
              onClick={onSubmit}
            >
              <svg
                width="12"
                height="9"
                viewBox="0 0 12 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.6665 6.61463L10.7945 0.485962L11.7378 1.42863L4.6665 8.49996L0.423828 4.2573L1.3665 3.31463L4.6665 6.61463Z"
                  fill="white"
                />
              </svg>
              <span className="vr-footer__label">Submit</span>
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default ApplicantFooter;
